module.exports = __webpack_public_path__ + "static/media/email_icon.e71a72a0.svg";